import { PanelBody, SelectControl, ToggleControl } from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import {THEME_VARIABLES, THEME_VARIABLES_MAP} from "~buildable/utils/constants";

const BlockColorOptions = props => {
  const options = THEME_VARIABLES;
  const map = THEME_VARIABLES_MAP;

  if (!options || !map) {
    return null;
  }

  const {
    setAttributes
  } = props;

  const {
    enableTransparentBg,
    bgColor,
    accentColor,
    noBgColor = false,
    noAccentColor = false,
    allowTransparentBg = false,
    append = null
  } = props.blockAttributes;

  let selectedBgColorStyle = {};
  if (bgColor) {
    selectedBgColorStyle.backgroundColor = map[bgColor];
  }

  let selectedAccentColorStyle = {};
  if (accentColor) {
    selectedAccentColorStyle.backgroundColor = map[accentColor];
  }

  return (
    <PanelBody
      className="color-options"
      title={ __('Color Options') }
    >
      { allowTransparentBg && (
        <ToggleControl
          label={ __("Enable Transparent Background") }
          checked={ enableTransparentBg }
          onChange={ enableTransparentBg => setAttributes({ enableTransparentBg }) }
        />
      ) }
      { (!noBgColor && (!allowTransparentBg || !enableTransparentBg)) && (
        <div className="color-select bg-color">
          <SelectControl
            label="Background Color"
            value={ bgColor }
            options={ options }
            onChange={ bgColor => setAttributes({ bgColor }) }
          />
          <div
            className="color-circle"
            style={ selectedBgColorStyle }
          />
        </div>
      ) }
      { !noAccentColor && (
        <div className="color-select accent-color">
          <SelectControl
            label="Accent Color"
            value={ accentColor }
            options={ options }
            onChange={ accentColor => setAttributes({ accentColor }) }
          />
          <div
            className="color-circle"
            style={ selectedAccentColorStyle }
          />
        </div>
      ) }
      { !!append && append }
    </PanelBody>
  )
}

export default BlockColorOptions;
